import '../utils/element-closest'; // For IE 11 only
import { createPopper } from '@popperjs/core';

function positionLangDropDown(e) {
    // console.log('create popper');
    const
        tg = e.target,
        dropDown = tg.querySelector('.dropdown-menu'),
        langIcon = tg.querySelector('#inx-lang-switch-button .ico-lang');

    createPopper(langIcon, dropDown, {
        placement: 'bottom',
        modifiers: [
            { name: 'flip',
                options: { fallbackPlacements: ['bottom-start'] }
            },
            { name: 'offset',
                options: { offset: [-3, 18] }
            },
        ]
    });
}

function goToLanguage(lang) {
    const params = {
        language: lang,
        persist_language: 1
    };
    let locSearch = location.search;
    Object.keys(params).forEach((key) => {
        const regEx = new RegExp('\\b' + key + '\\=[^&]+');
        if (locSearch.length && regEx.test(locSearch)) {
            locSearch = locSearch.replace(regEx, `${key}=${params[key]}`);
        }
        else {
            locSearch += (locSearch.length ? '&' : '?') + `${key}=${params[key]}`;
        }
    });
    location.href = [
        location.origin,
        location.pathname,
        locSearch,
        location.hash
    ].join('');
}

// Provides visual feedback while loading new language
function changeLanguage(e, switcher) {
    const liTag = e.target.closest('li');

    if(!liTag) return;

    const
        icon = switcher.querySelector('.ico-lang'),
        newLang = liTag.dataset.lang,
        newText = liTag.textContent,
        oldLang = icon.className.match(/\bflag-\w{2}/)[0];

    switcher.querySelector('.lang-label').textContent = newText;
    icon.classList.remove(oldLang);
    icon.classList.add(`flag-${newLang}`);

    goToLanguage(newLang);
}
export default selector => {
    const container = document.getElementById(selector);

    if (container === null) return;

    const
        switcher = container.querySelector('.language-switch'),
        dropdown = container.querySelector('.dropdown-menu');

    dropdown.addEventListener('click', e => changeLanguage(e, switcher));
    // Cannot use ".addEventListener" for custom jQuery events
    // https://stackoverflow.com/questions/34089457/are-jquery-events-usables-with-dom-addeventlistener
    $(container).on('shown.bs.dropdown', positionLangDropDown);
};
